const cards = [
  {
    title: '娱乐圈最新塌房实录：顶流艺人私生活全揭秘',
    desc: '独家整理近期娱乐圈多位顶流艺人的塌房事件时间线，从爆料到回应全纪录，还原每一处细节。',
    tag: '娱乐圈黑料',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20entertainment%20news%20concept%2C%20spotlight%20on%20empty%20stage%20with%20crimson%20curtains%2C%20mysterious%20atmosphere%2C%20low%20key%20lighting%2C%20editorial%20photography%20style%2C%20warm%20dark%20tones%2C%20no%20people%2C%20abstract%20composition&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    title: '互联网大厂内部黑料：高管邮件泄露风波全解析',
    desc: '某头部互联网公司内部邮件意外流出，揭示管理层不为人知的决策内幕和人事斗争。',
    tag: '大厂内幕',
    img: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20interior%20at%20night%2C%20empty%20desk%20with%20scattered%20documents%2C%20dramatic%20lighting%20from%20single%20source%2C%20mysterious%20corporate%20atmosphere%2C%20deep%20shadows%2C%20cinematic%20mood%2C%20no%20people%2C%20warm%20undertones&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    title: '网红圈恩怨全记录：头部主播之间的暗战与博弈',
    desc: '从平台竞争到私下互撕，盘点网红圈近年来最精彩的爱恨情仇和利益纠纷。',
    tag: '网红瓜田',
    img: 'https://readdy.ai/api/search-image?query=Dark%20social%20media%20concept%2C%20smartphone%20screen%20glowing%20in%20darkness%2C%20dramatic%20red%20accent%20lighting%2C%20mysterious%20digital%20atmosphere%2C%20low%20key%20photography%2C%20no%20recognizable%20content%20on%20screen%2C%20abstract%20composition&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    title: '财经圈暗流涌动：某上市公司财务疑云深度追踪',
    desc: '持续追踪某上市公司财务数据异常事件，从做空报告到监管介入全过程记录。',
    tag: '财经黑幕',
    img: 'https://readdy.ai/api/search-image?query=Dark%20financial%20concept%2C%20stock%20market%20data%20screens%20in%20dark%20room%2C%20dramatic%20crimson%20and%20charcoal%20tones%2C%20mysterious%20financial%20atmosphere%2C%20low%20key%20lighting%2C%20no%20people%2C%20abstract%20editorial%20style&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    title: '体育圈争议事件盘点：从裁判黑哨到转会内幕',
    desc: '梳理近期体育圈最具争议的几大事件，揭秘赛场之外不为人知的幕后故事。',
    tag: '体育争议',
    img: 'https://readdy.ai/api/search-image?query=Dark%20empty%20sports%20stadium%20at%20night%2C%20dramatic%20spotlight%20on%20field%2C%20mysterious%20atmosphere%2C%20deep%20shadows%2C%20cinematic%20sports%20photography%20style%2C%20no%20people%2C%20warm%20dark%20tones&width=800&height=500&seq=card-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">
          黑料故事
        </h2>
        <p className="text-sm text-foreground-400 text-center mb-10 md:mb-14">
          精选黑料事件深度揭秘，持续追踪后真相
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <article
              key={i}
              className="group bg-background-100 border border-background-200/60 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-500/30"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block text-xs font-medium text-primary-400 bg-primary-500/10 px-2.5 py-1 rounded-full mb-3 whitespace-nowrap">
                  {card.tag}
                </span>
                <h3 className="text-base md:text-lg font-semibold text-foreground-100 mb-2 line-clamp-2 group-hover:text-primary-400 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-400 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}